import { defineMessages } from "react-intl";

const baseId = "t.pages.login.";

export default defineMessages({
  title: {
    id: `${baseId}title`,
    defaultMessage: "LOGIN",
  },
  pageTitle: {
    id: `${baseId}pageTitle`,
    defaultMessage: "LOGIN",
  },
  labelUser: {
    id: `${baseId}labelUser`,
    defaultMessage: "user",
  },
  labelPwd: {
    id: `${baseId}labelPwd`,
    defaultMessage: "password",
  },
  forgottenPwd: {
    id: `${baseId}forgottenPwd`,
    defaultMessage: "Forgotten Pwd",
  },
  CTA_LOGIN: {
    id: `${baseId}CTA_LOGIN`,
    defaultMessage: "LOGIN",
  },
});
